import { Organization } from '../reducers/organizationReducer'

// Mirror of the backend filter in opening-pr-controller.js. Repositories with
// any other status (including `null` for legacy docs created before the
// `status` field had a default) should remain toggleable.
export const INACTIVE_REPO_STATUSES = ['archived', 'disabled', 'deleted']

export function isRepoActionable(repo) {
  return !INACTIVE_REPO_STATUSES.includes(repo?.status)
}

export async function fetchRepositoriesForOrg({ axios, orgId, dispatch }) {
  const result = await axios.get(`/repositories/opening-pr/${orgId}`)
  if (result.status === 200) {
    dispatch(Organization.actions.setRepositories(result.data))
    return result.data
  }
  return []
}

export async function toggleRepoOpeningPR({ axios, repoId, openingPR, dispatch }) {
  const result = await axios.put(`/repositories/${repoId}/opening-pr`, { openingPR })
  if (result.status === 200) {
    dispatch(Organization.actions.setRepository(result.data))
    return result.data
  }
  return null
}
